export default __webpack_public_path__ + "71f802c2e0ec6dda38dccce8dca69126.png";